module.exports = __webpack_public_path__ + "img/geolocalisation_famille_boutrais_small.dc30cbd7.png";